let arrival_data3 = [
    {
        id : 8,
        imgurl : '/img/newarrival/section3_men1.jpg',
        brand : 'JILLSTUART NEW YORK MEN',
        title : '라이트블루 나일론 밴딩 숏 팬츠',
        persent : '20%',
        price : '159,000',
        saleprice : '127,200',
    },
    {
        id : 9,
        imgurl : '/img/newarrival/section3_men2.jpg',
        brand : 'BROOKS BROTHERS',
        title : 'BB_시어서커 벵갈 스트라이프 스포츠 셔츠',
        persent : '20%',
        price : '139,000',
        saleprice : '127,150',
    },
    {
        id : 10,
        imgurl : '/img/newarrival/section3_men3.jpg',
        brand : 'BROOKS BROTHERS',
        title : 'BB_코튼 시어서커 스트라이프 쇼츠',
        persent : '10%',
        price : '139,000',
        saleprice : '125,100',
    },
    {
        id : 11,
        imgurl : '/img/newarrival/section3_men4.jpg',
        brand : 'LEVIS',
        title : 'DESTINATION TEE KOREA',
        persent : '10%',
        price : '39,000',
        saleprice : '35,810',
    },
]

export default arrival_data3